import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Headset } from 'lucide-react';
import { Card } from '@tcrd/ui';
import { useToast } from './toast';
import { api, errorMessage } from '../lib/api';

/** Abre el chat de soporte con la administración (se crea la primera vez). */
export function SupportButton({ base }: { base: '/app' | '/driver' }) {
  const history = useHistory();
  const toast = useToast();
  const [busy, setBusy] = useState(false);
  const open = async () => {
    setBusy(true);
    try {
      const c = await api<{ id: string }>('/support/conversation', { method: 'POST' });
      history.push(`${base}/chat/${c.id}`);
    } catch (e) {
      toast(errorMessage(e), 'danger');
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" className="tap text-left w-full disabled:opacity-60" disabled={busy} onClick={() => void open()}>
      <Card className="p-4 flex items-center gap-3">
        <Headset className="size-5 text-[var(--text-muted)]" aria-hidden />
        <span className="flex-1">
          <span className="block font-medium">Soporte</span>
          <span className="block text-xs text-[var(--text-muted)]">Escríbele a la administración por el chat</span>
        </span>
      </Card>
    </button>
  );
}
